import { useEffect } from "react";
import { useStyles } from "../../../context/StyleContext";
import { CALLBACKS, triggerCallback } from "../../../utils/commonUtils";
import { useTranslation } from "../../../hooks/useTranslation";
import DlocalUpiForm from "./DlocalUpiForm";
import { useCheckout } from "../../../context/CheckoutContext";
import { useIframeResize } from "../../../hooks/useIframeResize";

const AltruonDlocalUpiForm = ({
  formData,
  itemDetails,
  billingPlatformId,
  routingEntries,
  planId,
  platformItemDetails,
  checkoutPageConfDto, checkoutProcessDto }) => {
  const queryParams = new URLSearchParams(window.location.search);
  const sessionId = queryParams.get("session_id");
  const { styles } = useStyles();
  const { t } = useTranslation();
  const { triggerPaymentEvent } = useCheckout();

  useIframeResize({ enabled: true, padding: 40 });

  useEffect(() => {
    const handleMessage = (event) => {
      if (event?.data?.type === "makePayment") {
        triggerPaymentEvent();
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [triggerPaymentEvent]);

  const handleUpiIdChange = (upiId) => {
    window.parent.postMessage(
      { type: "updateUpiData", data: { upiId } }, "*");
  };

  const handlePanChange = (pan) => {
    window.parent.postMessage(
      { type: "updateUpiData", data: { pan } },
      "*"
    );
  };

  const onParentCallback = (event) => {
    switch (event.type) {
      case "finalizeFormData":
        window.parent.postMessage(event, "*");
        break;

      case "actionRequired":
        triggerCallback(CALLBACKS.ACTION_REQUIRED, {
          actionType: "REDIRECT",
          redirectUrl: event.url,
          message: "Payment initiated, redirecting you to complete the process...",
        });
        break;

      case "success":
        triggerCallback(CALLBACKS.SUCCESS, {
          transactionId: event.transactionId,
          message: "Payment successfully initiated.",
        });
        break;

      case "failure":
      default:
        triggerCallback(CALLBACKS.FAILURE, {
          status: "failed",
          message: event.message || "Transaction failed.",
        });
        break;
    }
  };

  return (
    <DlocalUpiForm
      formData={formData}
      itemDetails={itemDetails}
      billingPlatformId={billingPlatformId}
      routingEntries={routingEntries}
      planId={planId}
      platformItemDetails={platformItemDetails}
      checkoutPageConfDto={checkoutPageConfDto}
      checkoutProcessDto={checkoutProcessDto}
      styles={styles}
      onUpiIdChange={handleUpiIdChange}
      onPanChange={handlePanChange}
      onParentCallback={onParentCallback}
      sessionId={sessionId}
      isEmbeddedCheckout={true}
    />
  );
};

export default AltruonDlocalUpiForm;